module.exports = __webpack_public_path__ + "img/16_48.5d40f8c8.png";